import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import 'bootstrap';
import 'slick-carousel';
import Swal from 'sweetalert2/src/sweetalert2';
import Cookies from 'js-cookie';

import './scss/frontend/style.scss';

import './js/_section-sku-slider';
import './js/_section-sku-banner-slider';

$(function () {
    $(document).on('click', '.inner-link', function () {
        $('.navbar-collapse').collapse('hide');
    });
});
